import React, { useEffect, useState } from "react";
import { Trash2, ChevronDown, ChevronUp, RefreshCw } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";

// Lot 710 — Admin › Utilisateurs : historique des comptes supprimés via le formulaire public vérifié par code (lot 709) :
// date, membre, identifiant, message laissé, date de suppression définitive et état actuel (programmée / annulée / effacée).
const STATE = { scheduled: ["Suppression programmée", "#FEF3C7", "#92400E"], cancelled: ["Annulée (membre revenu)", "#DCFCE7", "#166534"], purged: ["Compte effacé", "#FEE2E2", "#991B1B"] };
const when = (s) => (s ? new Date(s).toLocaleString("fr-FR", { dateStyle: "medium", timeStyle: "short" }) : "—");

export const PublicDeletionsCard = ({ onOpenUser }) => {
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  const load = () => api.get("/admin/deletion-requests").then(({ data: d }) => setData(d)).catch(() => setData({ requests: [], total: 0 }));
  useEffect(() => { load(); }, []);
  const rows = data?.requests || [];
  return (
    <div className="yalola-card p-4" data-testid="public-deletions-card">
      <div className="flex items-center gap-2 flex-wrap">
        <div className="h-9 w-9 rounded-xl grid place-items-center" style={{ background: "#FEE2E2", color: "#991B1B" }}><Trash2 size={17} /></div>
        <div>
          <div className="font-bold font-display text-sm">Suppressions via le formulaire public <span className="chip text-[10px] ml-1" data-testid="public-deletions-count">{data?.total ?? "…"}</span></div>
          <div className="text-xs" style={{ color: "var(--yalola-text-muted)" }}>Comptes dont le propriétaire a confirmé la suppression par code depuis la page « Supprimer mon compte ».</div>
        </div>
        <div className="ml-auto flex items-center gap-2">
          <Button size="sm" variant="outline" className="rounded-full" onClick={load} data-testid="public-deletions-refresh"><RefreshCw size={13} /></Button>
          <Button size="sm" variant="outline" className="rounded-full" onClick={() => setOpen((o) => !o)} data-testid="public-deletions-toggle">{open ? <ChevronUp size={13} /> : <ChevronDown size={13} />} {open ? "Masquer" : "Afficher"}</Button>
        </div>
      </div>
      {open && (
        <div className="mt-3 overflow-x-auto" data-testid="public-deletions-list">
          {rows.length === 0 ? (
            <p className="text-sm" style={{ color: "var(--yalola-text-muted)" }} data-testid="public-deletions-empty">Aucune suppression confirmée via le formulaire public.</p>
          ) : (
            <table className="w-full text-xs">
              <thead><tr className="text-left" style={{ color: "var(--yalola-text-muted)" }}><th className="py-1 pr-2">Date</th><th className="py-1 pr-2">Membre</th><th className="py-1 pr-2">Identifiant</th><th className="py-1 pr-2">Message</th><th className="py-1 pr-2">Suppression définitive</th><th className="py-1 pr-2">État</th></tr></thead>
              <tbody>
                {rows.map((r) => {
                  const [label, bg, color] = STATE[r.state] || STATE.scheduled;
                  return (
                    <tr key={r.id} className="border-t" style={{ borderColor: "var(--yalola-border)" }} data-testid={`public-deletion-${r.id}`} data-state={r.state}>
                      <td className="py-1.5 pr-2 whitespace-nowrap">{when(r.created_at)}</td>
                      <td className="py-1.5 pr-2"><button type="button" className="underline font-semibold" onClick={() => onOpenUser?.(r.user_id)} data-testid={`public-deletion-user-${r.id}`}>{r.name || "—"}</button></td>
                      <td className="py-1.5 pr-2">{r.identifier || r.email || r.phone || "—"}</td>
                      <td className="py-1.5 pr-2 max-w-[260px] truncate" title={r.message || ""}>{r.message || <span className="opacity-40">—</span>}</td>
                      <td className="py-1.5 pr-2 whitespace-nowrap">{String(r.scheduled_for || "").slice(0, 10) || "—"}</td>
                      <td className="py-1.5 pr-2"><span className="chip text-[10px]" style={{ background: bg, color }}>{label}</span></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
};

export default PublicDeletionsCard;
